export const CZECH_LANGUAGE = "cs";
